import React from 'react'
import DeleteTheme from "./delete-theme";
import {deleteSingleTheme, updateSingleTheme} from "../services/theme-data-service";

const ThemeDetail = ({selectedTheme, setSelectedTheme, setSelectedThemeRemoved}) => {

    const handleSelectThemeChanges = async (event) => {
        const {name, value} = event.target;
        const theme = {...selectedTheme};
        theme[name] = value;

        setSelectedTheme(theme);
        await updateSingleTheme(theme);
    }

    const removeTheme = async () => {
        console.log('Remove Theme: ', selectedTheme);
        await deleteSingleTheme(selectedTheme);
        setSelectedThemeRemoved(true);
    }

    return (
        <>

            <div className="flex justify-between mb-7">
                <div className="title-label">
                    {selectedTheme?.startText}
                </div>

                <div className="float-right -mt-2">
                    <DeleteTheme theme={selectedTheme} removeTheme={removeTheme}/>
                </div>
            </div>

            <div className="overflow-y-scroll form-container">

                {selectedTheme &&
                    <>
                        <div className="field-group-container">
                            <div className="field-container w-full">
                                <div className="field-label">Start Text</div>
                                <input type="text" placeholder="Start Text"
                                       id="startText"
                                       name="startText"
                                       value={selectedTheme?.startText}
                                       onChange={handleSelectThemeChanges}
                                       className="input-field w-full"/>
                            </div>

                            <div className="field-container w-full">
                                <div className="field-label">Text</div>
                                <input type="text" placeholder="Text"
                                       id="text"
                                       name="text"
                                       value={selectedTheme?.text}
                                       readOnly={true}
                                       className="input-field read-only-field w-full"/>
                            </div>
                        </div>

                        <div className="field-group-container">
                            <div className="field-container w-full">
                                <div className="field-label">Display Text</div>
                                <textarea
                                    id="displayText"
                                    name="displayText"
                                    value={selectedTheme?.displayText}
                                    onChange={handleSelectThemeChanges}
                                    className="text-area-field"/>
                            </div>
                        </div>
                    </>
                }

            </div>
        </>
    )
}

export default ThemeDetail
